import React from 'react';
const Tour = () => {
return (
<div className="container mt-5">
<div className="row">
<div className="site-heading text-center">
              <h2>Product Tour</h2>
            </div>
{/* {/ Video Section /} */}
<div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
<div className="card shadow-lg p-3 mt-5 mb-5 video" style={{ border: 'none' }}>

<video
className="w-100 rounded"
controls
style={{ maxHeight: "400px", objectFit: "cover" }}
>
<source src="/KnackVibesVideoTour.mp4" type="video/mp4" />
Your browser does not support the video tag.
</video>
</div>
</div>
{/* {/ Content Section /} */}
<div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
<h3 className="mb-3 mt-5">Take a Quick Product Tour</h3>
<p>
Discover how our AI-driven hiring platform simplifies the recruitment process from start to finish.
Watch this short demo to see how effortlessly you can screen candidates, conduct online interviews,
and make smarter hiring decisions — all from one seamless dashboard.
</p>
<p>
Learn how our intelligent automation, real-time assessments, and user-friendly interface help you
find top talent faster — so you can focus on building a great team, not sorting through resumes.
</p>
</div>
</div>
</div>
);
};
export default Tour;